import { render, staticRenderFns } from "./EEscolhaDisciplinaMes.vue?vue&type=template&id=021cf3f0"
import script from "./EEscolhaDisciplinaMes.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplinaMes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports